import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询列表
export const queryLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLogs', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/message/log/page', payload);
    commit('setLogs', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};
